import React, { useState, useContext, useEffect } from "react";
import "./DepartmentDiscipline.css";
import { UserContext } from "../../../../contexts/CurrentUserContext";
import {
  getGroupAttendancesMonth,
  getGroupAttendances6Month,
  getGroupAttendancesYear,
} from "../../../../api/api";

const DepartmentDiscipline = () => {
  const { userData } = useContext(UserContext);
  const isAdms = userData?.access_levels?.some(
    (level) => level.name === "АДМС"
  );
  const [selectedPeriod, setSelectedPeriod] = useState("month");
  const [selectedMonth, setSelectedMonth] = useState(new Date());
  const [departmentsData, setDepartmentsData] = useState([]);
  const [topEmployeesData, setTopEmployeesData] = useState([]);
  const [bottomEmployeesData, setBottomEmployeesData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // Получаем группу текущего пользователя
  // Пытаемся найти основную группу пользователя из структуры departments -> groups
  const getUserGroup = () => {
    if (!userData || !userData.departments) return "";

    // Ищем первую активную группу в первом департаменте
    for (const department of userData.departments) {
      if (department.groups && department.groups.length > 0) {
        const activeGroup = department.groups.find((group) => group.is_active);
        if (activeGroup) {
          return activeGroup.name;
        }
        // Если нет активной группы, берем первую
        return department.groups[0].name;
      }
    }
    return "";
  };

  const userGroup = getUserGroup();

  // Отладочная информация
  console.log("DepartmentDiscipline - userData:", userData);
  console.log(
    "DepartmentDiscipline - userData.departments:",
    userData?.departments
  );
  console.log("DepartmentDiscipline - userGroup:", userGroup);
  console.log("DepartmentDiscipline - departmentsData:", departmentsData);

  // Загрузка данных из API
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      setError(null);
      try {
        let data;
        const year = selectedMonth.getFullYear();
        const month = selectedMonth.getMonth() + 1;

        // Выбираем нужный API в зависимости от периода
        if (selectedPeriod === "year") {
          data = await getGroupAttendancesYear(year);
        } else if (selectedPeriod === "6months") {
          const startYear = year;
          const startMonth = month;
          const endDate = new Date(selectedMonth);
          endDate.setMonth(endDate.getMonth() + 5);
          const endYear = endDate.getFullYear();
          const endMonth = endDate.getMonth() + 1;
          data = await getGroupAttendances6Month(
            startYear,
            startMonth,
            endYear,
            endMonth
          );
        } else {
          // selectedPeriod === "month"
          data = await getGroupAttendancesMonth(year, month);
        }

        // Преобразуем данные из API в формат для компонента
        const departments = data.on_time_rate.map((item, index) => {
          const latenessData = data.average_lateness.find(
            (l) => l.group_name === item.group_name
          );
          const officeTimeData = data.average_office_time.find(
            (o) => o.group_name === item.group_name
          );

          return {
            id: index + 1,
            name: item.group_name, // Используем group_name для сравнения с пользователем
            shortName: item.short_group_name || item.group_name, // Используем short_group_name для отображения
            punctualityPercent: item.on_time_percent,
            avgTardiness: latenessData ? latenessData.avg_late_time : 0,
            avgWorkDuration: officeTimeData
              ? officeTimeData.office_time
              : "0:00",
          };
        });

        setDepartmentsData(departments);

        // Функция для получения короткого названия отдела
        const getShortGroupName = (groupName) => {
          const department = departments.find(
            (dept) => dept.name === groupName
          );
          return department ? department.shortName : groupName;
        };

        // Преобразуем данные сотрудников из новой структуры API
        // Лидеры по пунктуальности (intime_leaders)
        const topUsers = data.intime_leaders
          ? data.intime_leaders.slice(0, 10).map((user, index) => ({
              id: index + 1,
              name: user.full_name,
              department: getShortGroupName(user.group_name),
              punctualityPercent: user.intime_percentage,
            }))
          : [];

        // Аутсайдеры по пунктуальности (lateness_leaders)
        const bottomUsers = data.lateness_leaders
          ? data.lateness_leaders.slice(0, 10).map((user, index) => ({
              id: index + 1,
              name: user.full_name,
              department: getShortGroupName(user.group_name),
              punctualityPercent: user.intime_percentage,
            }))
          : [];

        setTopEmployeesData(topUsers);
        setBottomEmployeesData(bottomUsers);
      } catch (err) {
        console.error("Ошибка при загрузке данных:", err);
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [selectedMonth, selectedPeriod]);

  const handleMonthChange = (direction) => {
    const newMonth = new Date(selectedMonth);
    if (direction === "prev") {
      if (selectedPeriod === "year") {
        newMonth.setFullYear(newMonth.getFullYear() - 1);
      } else if (selectedPeriod === "6months") {
        newMonth.setMonth(newMonth.getMonth() - 6);
      } else {
        newMonth.setMonth(newMonth.getMonth() - 1);
      }
    } else {
      if (selectedPeriod === "year") {
        newMonth.setFullYear(newMonth.getFullYear() + 1);
      } else if (selectedPeriod === "6months") {
        newMonth.setMonth(newMonth.getMonth() + 6);
      } else {
        newMonth.setMonth(newMonth.getMonth() + 1);
      }
    }
    setSelectedMonth(newMonth);
  };

  const formatMonthYear = (date) => {
    const months = [
      "Январь",
      "Февраль",
      "Март",
      "Апрель",
      "Май",
      "Июнь",
      "Июль",
      "Август",
      "Сентябрь",
      "Октябрь",
      "Ноябрь",
      "Декабрь",
    ];

    if (selectedPeriod === "year") {
      return `${date.getFullYear()}`;
    } else if (selectedPeriod === "6months") {
      const startMonth = new Date(date);
      const endMonth = new Date(date);
      endMonth.setMonth(endMonth.getMonth() + 5);
      return `${months[startMonth.getMonth()]} ${startMonth.getFullYear()} - ${
        months[endMonth.getMonth()]
      } ${endMonth.getFullYear()}`;
    } else {
      return `${months[date.getMonth()]} ${date.getFullYear()}`;
    }
  };

  // Функции для получения топ отделов
  const getTopDepartmentsByPunctuality = () => {
    return [...departmentsData].sort(
      (a, b) => b.punctualityPercent - a.punctualityPercent
    );
  };

  const getTopDepartmentsByDuration = () => {
    return [...departmentsData].sort((a, b) => {
      const aTime =
        parseInt(a.avgWorkDuration.split(":")[0]) * 60 +
        parseInt(a.avgWorkDuration.split(":")[1]);
      const bTime =
        parseInt(b.avgWorkDuration.split(":")[0]) * 60 +
        parseInt(b.avgWorkDuration.split(":")[1]);
      return bTime - aTime;
    });
  };

  // Компонент медали
  const MedalIcon = ({ position }) => {
    if (position === 1) return <span className="medal gold">🥇</span>;
    if (position === 2) return <span className="medal silver">🥈</span>;
    if (position === 3) return <span className="medal bronze">🥉</span>;
    return null;
  };

  const getTopEmployeesByPunctuality = () => {
    return topEmployeesData;
  };

  const getBottomEmployeesByPunctuality = () => {
    return bottomEmployeesData;
  };

  // Показываем загрузку
  if (isLoading) {
    return (
      <div className="department-discipline-container">
        <div className="loading-message">Загрузка данных...</div>
      </div>
    );
  }

  // Показываем ошибку
  if (error) {
    return (
      <div className="department-discipline-container">
        <div className="error-message">Ошибка: {error}</div>
      </div>
    );
  }

  return (
    <div className="department-discipline-container">
      {/* Заголовок страницы */}
      <div className="page-header">
        <h1 className="page-title">Рейтинг отделов</h1>
        <div className="period-buttons">
          <button
            className={`period-button ${
              selectedPeriod === "year" ? "active" : ""
            }`}
            onClick={() => setSelectedPeriod("year")}
          >
            Год
          </button>
          <button
            className={`period-button ${
              selectedPeriod === "6months" ? "active" : ""
            }`}
            onClick={() => setSelectedPeriod("6months")}
          >
            6 месяцев
          </button>
          <button
            className={`period-button ${
              selectedPeriod === "month" ? "active" : ""
            }`}
            onClick={() => setSelectedPeriod("month")}
          >
            Месяц
          </button>
        </div>
      </div>

      <div className="month-navigation">
        <button
          className="nav-button"
          onClick={() => handleMonthChange("prev")}
        >
          ←
        </button>
        <span className="current-month">{formatMonthYear(selectedMonth)}</span>
        <button
          className="nav-button"
          onClick={() => handleMonthChange("next")}
        >
          →
        </button>
      </div>

      {/* Раздел 1: Отделы-лидеры по пунктуальности */}
      <div className="department-section">
        <div className="department-section-header">
          <h2 className="section-title">Отделы-лидеры по пунктуальности</h2>
        </div>

        <div className="dept-punctuality-chart-section">
          <div className="dept-chart-title">% дней без опозданий</div>
          <div className="dept-vertical-chart">
            <div className="dept-chart-container">
              <div className="dept-chart-grid">
                <div className="dept-grid-line"></div>
                <div className="dept-grid-line"></div>
                <div className="dept-grid-line"></div>
                <div className="dept-grid-line"></div>
                <div className="dept-grid-line"></div>
                <div className="dept-grid-line"></div>
              </div>
              <div className="dept-bars-container">
                {getTopDepartmentsByPunctuality().map((dept, index) => {
                  const isUserDepartment = dept.name === userGroup;
                  console.log(
                    `Comparing: "${dept.name}" === "${userGroup}" = ${isUserDepartment}`
                  );
                  return (
                    <div key={dept.id} className="dept-vertical-bar-container">
                      <div className="dept-vertical-bar">
                        <div
                          className={`dept-bar-fill ${
                            isUserDepartment ? "dept-highlighted" : ""
                          }`}
                          style={{ height: `${dept.punctualityPercent}%` }}
                        >
                          {index < 3 && (
                            <div className="dept-medal-container">
                              <MedalIcon position={index + 1} />
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="dept-bar-label">{dept.shortName}</div>
                      <div className="dept-bar-value">
                        {Math.round(dept.punctualityPercent)}%
                        {isUserDepartment && (
                          <span className="dept-your-department">
                            Твой отдел
                          </span>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Раздел 2: Отделы-долгожители */}
      <div className="department-section">
        <div className="department-section-header">
          <h2 className="section-title">Отделы-долгожители</h2>
        </div>

        <div className="dept-duration-chart-section">
          <div className="dept-chart-title">
            Средняя продолжительность работы в офисе
          </div>
          <div className="dept-vertical-chart">
            <div className="dept-chart-container">
              <div className="dept-chart-grid">
                <div className="dept-grid-line"></div>
                <div className="dept-grid-line"></div>
                <div className="dept-grid-line"></div>
                <div className="dept-grid-line"></div>
                <div className="dept-grid-line"></div>
                <div className="dept-grid-line"></div>
              </div>
              <div className="dept-bars-container">
                {getTopDepartmentsByDuration().map((dept, index) => {
                  const isUserDepartment = dept.name === userGroup;
                  console.log(
                    `Duration chart - Comparing: "${dept.name}" === "${userGroup}" = ${isUserDepartment}`
                  );
                  return (
                    <div key={dept.id} className="dept-vertical-bar-container">
                      <div className="dept-vertical-bar">
                        <div
                          className={`dept-bar-fill dept-green ${
                            isUserDepartment ? "dept-highlighted" : ""
                          }`}
                          style={{
                            height: `${
                              ((parseInt(dept.avgWorkDuration.split(":")[0]) *
                                60 +
                                parseInt(dept.avgWorkDuration.split(":")[1])) /
                                600) *
                              100
                            }%`,
                          }}
                        >
                          {index < 3 && (
                            <div className="dept-medal-container">
                              <MedalIcon position={index + 1} />
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="dept-bar-label">{dept.shortName}</div>
                      <div className="dept-bar-value">
                        {dept.avgWorkDuration}
                        {isUserDepartment && (
                          <span className="dept-your-department">
                            Твой отдел
                          </span>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Раздел 3 и 4: Сотрудники-лидеры и аутсайдеры в одну строку (только для АДМС) */}
      {isAdms && (
        <div className="employees-section">
          <div className="employees-row">
            {/* Сотрудники-лидеры по пунктуальности */}
            <div className="dept-employee-chart">
              <div className="department-section-header">
                <h2 className="section-title">
                  Сотрудники-лидеры по пунктуальности
                </h2>
              </div>
              <div className="dept-employee-chart-section">
                <div className="dept-chart-title">% дней без опозданий</div>
                <div className="dept-vertical-chart">
                  <div className="dept-chart-container">
                    <div className="dept-bars-container">
                      {getTopEmployeesByPunctuality().map((emp, index) => (
                        <div
                          key={emp.id}
                          className="dept-employee-vertical-bar-container"
                        >
                          <div className="dept-employee-vertical-bar">
                            <div
                              className="dept-bar-fill dept-light-blue"
                              style={{ height: `${emp.punctualityPercent}%` }}
                            ></div>
                          </div>
                          <div className="dept-employee-bar-label">
                            {emp.name} ({emp.department})
                          </div>
                          <div className="dept-employee-bar-value">
                            {Math.round(emp.punctualityPercent)}%
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Сотрудники-аутсайдеры по пунктуальности */}
            <div className="dept-employee-chart">
              <div className="department-section-header">
                <h2 className="section-title">
                  Сотрудники-аутсайдеры по пунктуальности
                </h2>
              </div>
              <div className="dept-employee-chart-section">
                <div className="dept-chart-title">% дней без опозданий</div>
                <div className="dept-vertical-chart">
                  <div className="dept-chart-container">
                    <div className="dept-bars-container">
                      {getBottomEmployeesByPunctuality().map((emp, index) => (
                        <div
                          key={emp.id}
                          className="dept-employee-vertical-bar-container"
                        >
                          <div className="dept-employee-vertical-bar">
                            <div
                              className="dept-bar-fill dept-light-brown"
                              style={{ height: `${emp.punctualityPercent}%` }}
                            ></div>
                          </div>
                          <div className="dept-employee-bar-label">
                            {emp.name} ({emp.department})
                          </div>
                          <div className="dept-employee-bar-value">
                            {Math.round(emp.punctualityPercent)}%
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DepartmentDiscipline;
